import type { FaireProductEntity } from "../../entity_types/product";

export const p_cfetjf3wbq: FaireProductEntity = {
  token: "p_cfetjf3wbq",
  type: "product",
  name: "Brooklyn - 5lbs - Whole Bean Coffee",
  brandToken: "b_4db0zb0iws",
  brandName: "Partners Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/ca19926482f9384e3b0bbe66ffae58e2b9cbede88c288f35d0df18e017dbc549.jpeg",
  galleryImageUrls: [],
  priceDollars: 72.8,
  description: "A perennial filter classic, we use the Brooklyn blend as our go-to coffee of the day. Brimming with flavors of creamy cocoa, sweet toffee and rich dried fruits, this offering brews beautifully on the French Press at home and is equally tasty with or without milk.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐈𝐧𝐟𝐨\n• Producers Pedro Echavarria, Paz Family and Josue Morales\n• Tasting Notes Milk Chocolate, Toffee and Dried Fruit\n• Elevation 1,600 - 1,900 meters\n• Regions Antioquioa, Colombia, Santa Barbara, Honduras and Santa Rosa, Guatemala\n• Variety Various\n• Process Wet-Processed\n\n𝐅𝐚𝐫𝐦 𝐑𝐞𝐥𝐚𝐭𝐢𝐨𝐧𝐬𝐡𝐢𝐩\n• Yes\n\nA perfect fall favorite!",
  tags: [],
  msrpDollars: 126.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:48.837Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
